import React from 'react';
import {PracticeData} from '../components/PracticeData';
import {BankInfo} from '../components/BankInfo';
import {Files} from '../components/Files';
import {CompletedSteps} from '../components/CompletedSteps';
import {Kids} from '../components/Kids';

export function DetailsOverview({
                                  practiceData,
                                  bankInfo,
                                  files,
                                  completedSteps,
                                  kids,
                                }) {
  return (
    <div className="row">
      <div className="col-xxl-4 col-lg-6">
        <PracticeData data={practiceData} className="card-stretch gutter-b"/>
      </div>
      <div className="col-xxl-4 col-lg-6">
        <BankInfo data={bankInfo} className="card-stretch gutter-b"/>
      </div>
      <div className="col-xxl-4">
        <CompletedSteps data={completedSteps}
                        className="card-stretch gutter-b"/>
      </div>
      <div className="col-lg-12">
        <Files data={files} className="card-stretch gutter-b"/>
      </div>
      <div className="col-lg-12">
        <Kids data={kids} className="card-stretch gutter-b"/>
      </div>
    </div>
  );
}
